import React, {ForwardedRef, forwardRef} from 'react'

import {cn} from '@/src/shared/utils/twMerge'

const Body5 = forwardRef(
  (
    {children, className}: {children: React.ReactNode; className?: string},
    ref: ForwardedRef<HTMLParagraphElement>
  ) => {
    return (
      <p
        ref={ref}
        className={cn(
          'lg:text-base',
          'text-sm',
          'text-gray-800',
          'font-normal',
          'leading-normal tracking-wide',
          className
        )}>
        {children}
      </p>
    )
  }
)

Body5.displayName = 'Body5'

export default Body5
